<ng-container>
    <button
            mat-icon-button
            cdkOverlayOrigin
            #origin="cdkOverlayOrigin"
            class="info-button"
            [attr.data-rowindex]="index"
            [attr.title]="tooltip | translate"
            (click)="togglePopover($event)">
        <mat-icon [svgIcon]="icon"></mat-icon>
    </button>

    <ng-template
            cdkConnectedOverlay
            [cdkConnectedOverlayOrigin]="origin"
            [cdkConnectedOverlayOpen]="openPopover"
            [cdkConnectedOverlayHasBackdrop]="true"
            [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
            (backdropClick)="openPopover = false"
            [cdkConnectedOverlayPositions]="popoverPositions"
            [cdkConnectedOverlayPanelClass]="'popover'"
    >
        <div class="popover-content" (click)="$event.stopPropagation()">
            <p class="text-white fw-bold" *ngIf="title">{{ title | translate }}</p>
            <p *ngIf="content">{{ content | translate }}</p>
            <p *ngIf="!content && noContentMessage">{{ noContentMessage | translate }}</p>
        </div>
    </ng-template>
</ng-container>
